import { Osoba   } from './osoba';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { TabsContainerService, BaseTabsContainer, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-osoba-tabs',
  templateUrl: './osoba-tabs.component.html',
  providers: [
    TabsContainerService
  ]
})
export class OsobaTabsComponent
 extends BaseTabsContainer<Osoba> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<Osoba>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }

}
